module.exports = __webpack_public_path__ + "static/media/ic_pw_bg.0da6b05a.png";